import axios, { AxiosResponse } from 'axios';
import CartItem from '@/classes/CartItem';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';
import { getCookie } from '@/helpers';
import CartInterface from '@/interfaces/CartInterface';

class CartAPI {
  public static mapResponse(response: AxiosResponse<any>): CartInterface {
    const cartResponseData = response?.data?.data?.cartData;
    const cartData = {
      campaigns: [],
    } as CartInterface;

    Object.keys(cartResponseData).forEach((categoryKey) => {
      cartData[categoryKey] = [];

      Object.keys(cartResponseData[categoryKey]).forEach((cartItemKey) => {
        const cartItemData = cartResponseData[categoryKey][cartItemKey];
        cartItemData.product = new Product(cartItemData.product as ProductInterface);

        cartData[categoryKey].push(new CartItem(cartItemKey, cartItemData));
      });
    });

    return cartData;
  }

  static get(): Promise<CartInterface> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.get(`${ajaxUrl}?action=cart`, {
        params: {
          endpoint: 'get',
          cartKey: getCookie('io_shop_cart'),
        },
      }).then((response) => {
        resolve(this.mapResponse(response) as CartInterface);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static add(product: Product, params: Record<string, any>, cartItemKey: string | null, additionalData: Record<string, any> = {}): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'add',
        cartKey: getCookie('io_shop_cart'),
        product: product.attributes,
        params,
        additionalData,
        cartItemKey,
      }).then((response) => {
        resolve({
          cartData: this.mapResponse(response),
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static remove(itemKey: string, product: Product): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'remove',
        cartKey: getCookie('io_shop_cart'),
        itemKey,
        type: product.productType,
      }).then((response) => {
        resolve({
          cartData: this.mapResponse(response),
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static hasCartCookie(): boolean {
    return `${getCookie('io_shop_cart')}`.trim() !== '';
  }
}

export default CartAPI;
